// How-to videos (YouTube links) shown as a play button beside the thing they explain — the same <VideoHelpButton> the contest
// tasks use (components/common; their links live in config/contestVideos.js). Paste any YouTube link: youtu.be/… or
// youtube.com/watch?v=… (see utils/youtube.js).

// Buying credit and paying: profile menu → ক্রেডিট কিনুন → pick a package → agree to the terms → pay (Buy Credit tab, next to the terms line).
export const PAYMENT_GUIDE_VIDEO_URL = 'https://youtu.be/qMzDc5IyxKs';
